import { Box, styled } from '@mui/material';
import { LocaleContext } from 'new/i18n/LocaleContext';
import { DentistInfo } from 'new/modules/EnrollPage/types';
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

const Wrapper = styled(Box)(() => ({
  padding: '20px 0',
  textAlign: 'center',
  fontFamily: 'Barlow Semi Condensed',
  color: '#444',

  '.program-name': {
    fontSize: '2rem',
    fontWeight: 700,
    textAlign: 'center',
    paddingTop: '1rem',
  },

  '.program-description': {
    textAlign: 'center',
    fontSize: '0.8rem',
    color: '#888',
    width: '60%',
    margin: '0 auto',
  },
  '.centered_logo': {
    maxWidth: '200px',
    margin: '0 auto',
    verticalAlign: 'middle',
    maxHeight: '90px',
    display: 'block',
    backgroundColor: '#fff',
  },
}));

type Props = {
  dentistInfo: DentistInfo;
};

const ClassicTitle: React.FC<Props> = ({ dentistInfo }) => {
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const isSpanish = locale == 'es-US';
  const programName =
    isSpanish && dentistInfo.spanishProgramName
      ? dentistInfo.spanishProgramName
      : dentistInfo.programName;
  const programDescription =
    isSpanish && dentistInfo.spanishProgramDescription
      ? dentistInfo.spanishProgramDescription
      : dentistInfo.programDescription;
  return (
    <Wrapper>
      <div>
        <a
          href={
            dentistInfo.url
              ? dentistInfo.url.indexOf('http') != -1
                ? dentistInfo.url
                : 'http://' + dentistInfo.url
              : ''
          }
        >
          <img src={dentistInfo.logo} className="centered_logo" />
        </a>
      </div>
      <div className="program-name">
        {programName
          ? programName
          : intl.formatMessage(
              { id: 'signup.externalLanding.classic.membershipPlan' },
              { name: dentistInfo.officeName },
            )}
      </div>
      {programDescription && (
        <div className="program-description">{programDescription}</div>
      )}
    </Wrapper>
  );
};

export default ClassicTitle;
